import { useEffect } from 'react'

import { SettingsMenu } from './Components/Menu/SettingsMenu'
import { SettingsRoutes } from './SettingsRoutes'

import './SettingsPage.sass'

const SettingsPage = () => {
  useEffect(() => {
    const codeEffectsScript = document.getElementById('code-effects-script')
    if (!codeEffectsScript) {
      const scriptEl = document.createElement('script')
      scriptEl.id = 'code-effects-script'
      scriptEl.src = `${process.env.PUBLIC_URL}/_vendor/CodeEffects/editor.js`
      scriptEl.defer = true
      document.body.append(scriptEl)
    }
  }, [])

  return (
    <>
      <div className="settings-page">
        <SettingsMenu />
        <div className="settings-container">
          <SettingsRoutes />
        </div>
      </div>
      <div id="material-selector-modal" />
    </>
  )
}

export default SettingsPage
